import {createSlice, nanoid} from '@reduxjs/toolkit';

const initialState = {
  items: []
}

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    // Payload is the message
    messageAdded: {
      reducer(state, action) {
        state.items.push(action.payload)
      },
      prepare(text) {
        return {
          payload: {
            id: nanoid(),
            open: true,
            text
          }
        }
      }
    },
    // Payload is ID of message to delete
    messageDeleted(state, action) {
      state.items = state.items.filter(item => item.id !== action.payload)
    },
    // Payload is ID of message to close
    messageClosed(state, action) {
      let message = state.items.filter(item => item.id === action.payload)[0]
      message.open = false
     //state.items = [...state.items, message]
    }
  }
})

export const { messageAdded, messageDeleted, messageClosed } = messagesSlice.actions

export default messagesSlice.reducer

export const selectAllMessages = state => state.messages.items